import { orderBy } from "firebase/firestore";
import { useFirestoreCollection } from "../../lib/useFirestoreCollection";
import ImageUploader from "../../components/admin/ImageUploader.jsx";

export default function HeroImagesPage() {
  const { items } = useFirestoreCollection("heroImages", orderBy("order"));

  return (
    <section style={{ display: "grid", gap: "1.5rem" }}>
      <header>
        <span className="mono-tag">// 01 — Hero</span>
        <h1
          style={{
            fontSize: "var(--step-3)",
            fontWeight: 300,
            letterSpacing: "-0.02em",
            marginTop: "0.5rem",
          }}
        >
          Imágenes del <strong>Hero</strong>
          <span style={{ color: "var(--color-accent)" }}>.</span>
        </h1>
        <p style={{ color: "var(--color-ink-soft)", marginTop: "0.5rem", maxWidth: "60ch" }}>
          La primera imagen activa (menor <code>order</code>) se muestra en la
          home. Desactiva las demás sin borrarlas para alternar piezas.
        </p>
      </header>

      <ImageUploader
        collectionPath="heroImages"
        storageFolder="hero"
        existing={items}
        onChange={() => {}}
      />
    </section>
  );
}
